import { ThemeUIStyleObject } from 'theme-ui'

const TOTAL = 'Total'

export const infoTable: ThemeUIStyleObject = {
  width: '100%',
  borderSpacing: 0,
  marginBottom: 24,
  marginTop: 8,
  ' > tbody > tr:not(last-of-type)not(:nth-of-type(even))': {
    border: 'hidden'
  },
  ' > tbody > tr:last-of-type:nth-of-type(even)': {
    borderBottom: '1px solid',
    borderBottomColor: 'grey-20'
  }
}

export const tableValue: ThemeUIStyleObject = {
  display: 'flex',
  justifyContent: 'flex-end',
  paddingRight: 16,
  fontWeight: '700',
  color: '#141424'
}

export const tableLabel = (label: string): ThemeUIStyleObject => ({
  width: '50%',
  fontWeight: label === TOTAL ? '700' : '400',
  color: '#141424'
})

export const tableHeading: ThemeUIStyleObject = {
  fontWeight: 700,
  color: '#141424'
}

export const infoList: ThemeUIStyleObject = {
  margin: 8,
  paddingLeft: 20,
  color: '#141424',
  listStyle: 'initial'
}

export const header: ThemeUIStyleObject = {
  display: 'flex',
  alignItems: 'center',
  '> img': {
    marginRight: 16
  },
  marginBottom: 24,
  marginTop: 24
}

export const modalButton: ThemeUIStyleObject = {
  marginBottom: 24
}
